export default { sha: '6686eb4fe2fc64cacea5bf25df8599e70ec77cad', buildNumber: 'undefined' }
